export const ViewportBreakpoints = {
  phoneUpper: '600px',
  tabletPortraitUpper: '900px',
  tabletLandscapeUpper: '1200px',
  desktopUpper: '1800px',
};
